import { HitsType } from './recommendation.types';
const recommendLabels = {
  [HitsType.recommendedApps]: {
    title: 'Recommended for you',
    description: 'Based on the apps that are currently installed on your $product instance'
  },
  [HitsType.newAndNoteworthyApps]: {
    title: 'New and Noteworthy apps',
    description: ''
  }
};
export default recommendLabels;